import React from "react";
import { AlertTriangle, Info } from "lucide-react";

import { pct, reais } from "../comum/formato";

// Transparência: o que é estimado e o que está vendendo abaixo do custo.
export default function Avisos({ resumo, abaixoDoCusto }) {
  return (
    <>
      {abaixoDoCusto?.length > 0 && (
        <section className="rounded-xl border border-red-500/40 bg-red-500/5 p-4" data-e2e="abaixo-do-custo">
          <h3 className="font-semibold flex items-center gap-2 text-red-600 dark:text-red-400"><AlertTriangle className="w-4 h-4" /> Vendendo abaixo do custo da ficha técnica</h3>
          <ul className="mt-2 space-y-1 text-sm">
            {abaixoDoCusto.map((p) => (
              <li key={p.produto_id} className="flex justify-between gap-3">
                <span>{p.produto}</span>
                <span className="tabular-nums">preço médio {reais(p.preco_medio)} · custo {reais(p.custo_unit)} · <b className="text-red-500">{reais(p.lucro_unit)} por unidade</b></span>
              </li>
            ))}
          </ul>
        </section>
      )}
      {resumo?.estimado_pct > 0 && (
        <p className="flex gap-2 rounded-xl border bg-muted/40 p-3 text-xs text-muted-foreground" data-e2e="aviso-estimado">
          <Info className="w-4 h-4 shrink-0 mt-px" />
          <span>
            {pct(resumo.estimado_pct)} das vendas são de antes de o pedido guardar qual promoção vendeu (versão 1.5.719). Pra elas, a promoção foi identificada
            pelo produto e pelas regras da promoção, e o desconto usa o preço cheio de hoje.
            {resumo.cobertura_desconto_pct < 100 ? ` O desconto considera ${pct(resumo.cobertura_desconto_pct)} das vendas — nas linhas "Sem registro da promoção" o preço cheio da época se perdeu.` : ""}
            {resumo.cobertura_custo_pct < 100 ? ` O lucro considera ${pct(resumo.cobertura_custo_pct)} das vendas — o resto não tem ficha técnica.` : ""}
          </span>
        </p>
      )}
    </>
  );
}
